export default __webpack_public_path__ + "static/media/minusIconRestaurant.c74d7eb0.svg";